import { createClientId } from '@/services/casePrepBuddyStorage';

function uniqueWarnings(input) {
  return Array.from(new Set((Array.isArray(input) ? input : []).filter(Boolean)));
}

function buildCandidateNotes({ sharedNotes, fileName, sheetName, rowIndex }) {
  const parts = [String(sharedNotes || '').trim()].filter(Boolean);

  if (fileName) {
    const rowLabel = typeof rowIndex === 'number' ? `row ${rowIndex + 1}` : 'row';
    parts.push(`Imported from ${fileName}${sheetName ? ` (${sheetName})` : ''}, ${rowLabel}.`);
  }

  return parts.join(' ');
}

export function buildCasePrepCandidatesFromImport({
  entries,
  sourceItemId,
  sharedNotes = '',
  fileName = '',
  sheetName = ''
}) {
  const normalizedEntries = Array.isArray(entries) ? entries : [];

  return normalizedEntries
    .filter((entry) => String(entry?.txHash || '').trim())
    .map((entry) => ({
      id: createClientId('candidate'),
      txHash: String(entry.txHash || '').trim(),
      toAddress: String(entry.toAddress || '').trim(),
      network: String(entry.network || '').trim(),
      validationState: entry.status === 'ready' ? 'unverified' : 'needs_review',
      lookupStatus: entry.lookupStatus || 'not_attempted',
      notes: buildCandidateNotes({
        sharedNotes,
        fileName,
        sheetName,
        rowIndex: entry.rowIndex
      }),
      warnings: uniqueWarnings(entry.warnings),
      sourceItemId,
      provenance: [
        {
          type: 'tabular_import',
          sourceItemId,
          fileName,
          sheetName,
          rowIndex: entry.rowIndex
        }
      ]
    }));
}
